<template>
  <div
    v-if="state.isShow"
    :style="{ width: state.formWidth(form.input_position) }"
  >
    <div v-if="form.input_type === 'text'">
      <div class="mb-6">
        <label
          :for="`itemId` + form.id"
          class="inline-block text-gray-92 font-semibold leading-4 mb-3"
          >{{ form.input_question }}</label
        >
        <span
          v-if="state.isRequired"
          class="ml-2 text-coral-main font-semibold"
          style="font-size: 11px"
          >必須</span
        >
        <span v-if="ruleItems.max" class="text-xs text-gray-62 float-right"
          >上限あと{{
            ruleItems.max -
            state.inputValueModel.items[state.inputValueIndex].values.length
          }}字</span
        >
        <div v-if="form.input_note" class="text-xs mb-2 text-gray-92">
          {{ form.input_note }}
        </div>
        <Field
          as="input"
          type="text"
          :name="'itemId' + form.id"
          :id="'itemId' + form.id"
          class="block min-w-full px-4 py-3 font-light border rounded leading-4"
          :class="{ 'border-danger': errors['itemId' + form.id] }"
          :maxlength="ruleItems.max || 1000"
          :placeholder="form.input_example"
          v-model="state.inputValueModel.items[state.inputValueIndex].values"
        />
        <ErrorMessage
          :name="'itemId' + form.id"
          as="span"
          class="block text-danger text-xs leading-6"
        />
      </div>
    </div>

    <div v-if="form.input_type === 'textarea'">
      <div class="mb-6">
        <label
          :for="'itemId' + form.id"
          class="inline-block text-gray-92 font-semibold leading-4 mb-3"
          >{{ form.input_question }}</label
        >
        <span
          v-if="state.isRequired"
          class="ml-2 text-coral-main font-semibold"
          style="font-size: 11px"
          >必須</span
        >
        <div v-if="form.input_note" class="text-xs mb-2 text-gray-92">
          {{ form.input_note }}
        </div>
        <Field
          as="textarea"
          :name="'itemId' + form.id"
          :id="'itemId' + form.id"
          class="block min-w-full px-4 py-3 border resize-none rounded"
          :class="{ 'border-danger': errors['itemId' + form.id] }"
          style="height: 100px; line-height: 18px"
          :placeholder="form.input_example"
          v-model="state.inputValueModel.items[state.inputValueIndex].values"
        />
        <ErrorMessage
          :name="'itemId' + form.id"
          as="span"
          class="block text-danger text-xs leading-6"
        />
      </div>
    </div>

    <div v-if="form.input_type === 'date'">
      <div class="mb-6">
        <label
          :for="'itemId' + form.id"
          class="inline-block text-gray-92 font-semibold leading-4 mb-3"
          >{{ form.input_question }}</label
        >
        <span
          v-if="state.isRequired"
          class="ml-2 text-coral-main font-semibold"
          style="font-size: 11px"
          >必須</span
        >
        <div v-if="form.input_note" class="text-xs mb-2 text-gray-92">
          {{ form.input_note }}
        </div>
        <Field
          as="input"
          type="date"
          :name="'itemId' + form.id"
          :id="'itemId' + form.id"
          class="block w50 px-4 py-3 border rounded leading-4 h-10 body-md"
          :class="{ 'border-danger': errors['itemId' + form.id] }"
          :placeholder="form.input_example"
          v-model="state.inputValueModel.items[state.inputValueIndex].values"
        />
        <ErrorMessage
          :name="'itemId' + form.id"
          as="span"
          class="block text-danger text-xs leading-6"
        />
      </div>
    </div>

    <div
      v-if="form.input_type === 'select'"
      v-click-outside="
        () => {
          state.toggleOptionSelect = false;
        }
      "
    >
      <div class="mb-6">
        <label
          :for="'itemId' + form.id"
          class="inline-block text-gray-92 font-semibold leading-4 mb-3"
          >{{ form.input_question }}</label
        >
        <span
          v-if="state.isRequired"
          class="ml-2 text-coral-main font-semibold"
          style="font-size: 11px"
          >必須</span
        >
        <div v-if="form.input_note" class="text-xs mb-2 text-gray-92">
          {{ form.input_note }}
        </div>
        <div
          class="selectbox"
          :class="{ 'border-danger': errors['itemId' + form.id] }"
        >
          <div
            class="selectbox-box"
            @click="state.toggleOptionSelect = !state.toggleOptionSelect"
          >
            <span
              v-if="!state.inputValueModel.items[state.inputValueIndex].values"
              >選択して下さい</span
            >
            <span
              v-else
              v-for="(item, key) in form.options"
              v-show="
                item.id ==
                state.inputValueModel.items[state.inputValueIndex].values
              "
              :key="'selected' + key"
              >{{
                form.display_format_type === 'number'
                  ? amountFormatter(item.name)
                  : item.name
              }}{{ form.unit || '' }}</span
            >
          </div>
          <div class="selectbox-selector" v-show="state.toggleOptionSelect">
            <div
              class="selectbox-selector-option"
              :class="{
                active:
                  state.inputValueModel.items[state.inputValueIndex].values ==
                  option.id,
              }"
              v-for="option in form.options"
              :key="'optionId' + option.id"
              @click="
                changeSelectBox(option.id), $emit('reset-hidden-item-input')
              "
            >
              {{
                form.display_format_type === 'number'
                  ? amountFormatter(option.name)
                  : option.name
              }}{{ form.unit || '' }}
            </div>
          </div>
        </div>
        <Field
          as="select"
          class="hidden"
          :name="'itemId' + form.id"
          :disabled="form.input_disabled"
          v-model="state.inputValueModel.items[state.inputValueIndex].values"
        >
          <option
            v-for="option in form.options"
            :value="option.id"
            :key="'hiddenOption' + option.id"
          />
        </Field>
        <ErrorMessage
          :name="'itemId' + form.id"
          as="span"
          class="text-danger leading-6"
        />
      </div>
    </div>

    <div v-if="form.input_type === 'checkbox'">
      <div class="mb-6">
        <label
          :for="'itemId' + form.id"
          class="inline-block text-gray-92 font-semibold leading-4 mb-3"
          >{{ form.input_question }}</label
        >
        <span
          v-if="state.isRequired"
          class="ml-2 text-coral-main font-semibold"
          style="font-size: 11px"
          >必須</span
        >
        <div v-if="form.input_note" class="text-xs mb-2 text-gray-92">
          {{ form.input_note }}
        </div>
        <div class="flex flex-wrap text-gray-92">
          <div
            class="pb-2 pr-2"
            style="width: calc(100% / 3)"
            v-for="option in form.options"
            :key="'optionId' + option.id"
          >
            <label
              :for="'itemId' + form.id + 'optionId' + option.id"
              class="flex leading-4 body-md"
            >
              <Field
                as="input"
                type="checkbox"
                :name="'itemId' + form.id"
                :id="'itemId' + form.id + 'optionId' + option.id"
                :value="option.id"
                v-model="
                  state.inputValueModel.items[state.inputValueIndex].values
                "
                @change="$emit('reset-hidden-item-input')"
              />
              <span class="ml-3"
                >{{
                  form.display_format_type === 'number'
                    ? amountFormatter(option.name)
                    : option.name
                }}{{ form.unit || '' }}</span
              >
            </label>
          </div>
        </div>
        <ErrorMessage
          :name="'itemId' + form.id"
          as="span"
          class="block text-danger text-xs leading-6"
        />
      </div>
    </div>

    <div v-if="form.input_type === 'radio'">
      <div class="mb-6">
        <label
          :for="'itemId' + form.id"
          class="inline-block text-gray-92 font-semibold leading-4 mb-3"
          >{{ form.input_question }}</label
        >
        <span
          v-if="state.isRequired"
          class="ml-2 text-coral-main font-semibold"
          style="font-size: 11px"
          >必須</span
        >
        <div v-if="form.input_note" class="text-xs mb-2 text-gray-92">
          {{ form.input_note }}
        </div>
        <div class="flex flex-wrap text-gray-92">
          <div
            class="pb-2 pr-2"
            style="width: calc(100% / 3)"
            v-for="option in form.options"
            :key="'optionId' + option.id"
          >
            <Field
              as="input"
              type="radio"
              :name="'itemId' + form.id"
              :id="'itemId' + form.id + 'optionId' + option.id"
              :value="option.id"
              v-model="
                state.inputValueModel.items[state.inputValueIndex].values
              "
              @change="$emit('reset-hidden-item-input')"
            />
            <label
              :for="'itemId' + form.id + 'optionId' + option.id"
              class="flex radio-label leading-4 mb-2 body-md"
            >
              <span class="ml-2"
                >{{
                  form.display_format_type === 'number'
                    ? amountFormatter(option.name)
                    : option.name
                }}{{ form.unit || '' }}</span
              >
            </label>
          </div>
        </div>
        <ErrorMessage
          :name="'itemId' + form.id"
          as="span"
          class="block text-danger text-xs leading-6"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import { Field, ErrorMessage } from 'vee-validate';
import { amountFormatter } from '@/utils/filters.js';

export default {
  props: {
    inputValue: Object,
    form: Object,
    errors: Object,
    hiddenItems: Object,
    rules: String,
  },
  components: {
    Field,
    ErrorMessage,
  },
  emits: ['reset-hidden-item-input'],
  setup(props) {
    const state = reactive({
      inputValueModel: computed(() => {
        return props.inputValue;
      }),
      inputValueIndex: computed(() => {
        return state.inputValueModel.items.findIndex(
          (i) => i.id == props.form.id
        );
      }),
      isRequired: computed(() => {
        if (props.form.input_validation_rule == null) {
          return false;
        }
        return props.form.input_validation_rule.indexOf('required') >= 0;
      }),
      isDisplayedHiddenItem: computed(() => {
        return props.hiddenItems[props.form.id] === false;
      }),
      formWidth: computed(() => (position) => {
        let width = '100%';
        if (position === 'left' || position === 'right') {
          width = 'calc(50% - 20px)';
        }
        return width;
      }),
      isShow: computed(() => {
        if (!Object.keys(props.form).length || !props.hiddenItems) return true;
        return (
          props.hiddenItems[props.form.id] === undefined ||
          props.hiddenItems[props.form.id] === true
        );
      }),
      toggleOptionSelect: false,
    });

    const changeSelectBox = (id) => {
      state.inputValueModel.items[state.inputValueIndex].values = id;
      state.toggleOptionSelect = false;
    };

    const ruleItems = {};
    if (props.rules) {
      props.rules.split('|').forEach((rule) => {
        if (rule) {
          const items = rule.split(':');
          ruleItems[items[0]] = items[1] || '';
        }
      });
    }

    return {
      state,
      amountFormatter,
      changeSelectBox,
      ruleItems,
    };
  },
};
</script>

<style lang="scss" scoped>
.w50 {
  width: calc(50% - 20px);
}
.selectbox {
  position: relative;
  width: 100%;
  height: 40px;
  background: #fff;
  @apply border;
  border-radius: 4px;
  cursor: pointer;
  &.border-danger {
    border-color: #d94f57;
  }
  &:after {
    position: absolute;
    top: 18px;
    right: 16px;
    display: block;
    content: '';
    width: 11px;
    height: 11px;
    border: 5.5px solid transparent;
    border-top: 5.5px solid rgba(6, 16, 26, 0.92); // border-gray-92
    box-sizing: border-box;
  }
  &-box {
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
  }
  &-selector {
    position: absolute;
    top: 40px;
    left: 0;
    background: #fff;
    width: 100%;
    max-height: 356px;
    padding: 16px 0;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3);
    overflow-y: scroll;
    z-index: 20;
  }
  &-selector-option {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 16px;
    @apply text-gray-62;
    line-height: 32px;
    box-sizing: border-box;
    &.active {
      @apply text-gray-92;
    }
    &:hover {
      @apply text-gray-92;
      background: #f1f2f6;
    }
  }
}
input[type='checkbox'] {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 14px;
  &::before {
    position: absolute;
    background: #fff;
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    @apply border;
    border-radius: 3px;
  }
  &::after {
    position: absolute;
    top: 2px;
    left: 6px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    content: '';
    display: block;
    width: 5px;
    height: 9px;
    opacity: 0;
    transform: rotate(48deg);
  }
  &:hover::before {
    @apply border border-gray-92;
    box-shadow: 0px 0px 0px 2px rgba(52, 68, 100, 0.1);
  }
  &:checked::before {
    background: #28395c;
    border: 1px solid #28395c;
  }
  &:checked::after {
    opacity: 1;
  }
}

input[type='radio'] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  + .radio-label {
    display: flex;
    &:before {
      content: '';
      background: #fff;
      border-radius: 100%;
      @apply border;
      display: inline-block;
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
    }
    &:hover::before {
      border: 1px solid #2cb2b2;
      box-shadow: 0px 0px 0px 2px rgba(73, 168, 174, 0.2);
    }
  }
  &:checked {
    + .radio-label {
      &:before {
        background-color: #2cb2b2;
        border: 1px solid #2cb2b2;
        box-shadow: inset 0 0 0 2px #fff;
      }
    }
  }
}
</style>
